import React, { useState, useEffect } from 'react';
import './Home.css';

const Home = ({ onSectionChange }) => {
  const [cyclesCount, setCyclesCount] = useState(0);
  const [co2Count, setCo2Count] = useState(0);
  // const [savingsCount, setSavingsCount] = useState(0);

  // Animation function for counting up
  const animateCount = (setter, target, duration = 2000, suffix = '') => {
    const start = 0;
    const increment = target / (duration / 16); // 60fps
    let current = start;
    
    const timer = setInterval(() => {
      current += increment;
      if (current >= target) {
        setter(target);
        clearInterval(timer);
      } else {
        setter(Math.floor(current));
      }
    }, 16);
  };

  useEffect(() => {
    // Start animations with staggered delays
    setTimeout(() => animateCount(setCyclesCount, 40), 500);
    setTimeout(() => animateCount(setCo2Count, 14000), 800);
    // setTimeout(() => animateCount(setSavingsCount, 200000), 1100);
  }, []);

  return (
    <section className="home-section">
      <div className="home-content">
        <div className="hero-text">
          <h1 className="hero-title">RePedal Initiative</h1>
          <p className="hero-quote">
            "Affordable and Sustainable Commute in Campus"
          </p>
          
          <div className="stats-container">
            <div className="stat-item">
              <div className="stat-number">{cyclesCount}+</div>
              <div className="stat-label">Cycles to be Available</div>
            </div>
            <div className="stat-item">
              <div className="stat-number">{co2Count.toLocaleString()}+</div>
              <div className="stat-label">kg CO₂e Emissions can be Mitigated</div>
            </div>
            {/* <div className="stat-item">
              <div className="stat-number">₹{savingsCount.toLocaleString()}+</div>
              <div className="stat-label">Money Saved</div>
            </div> */}
          </div>

          <button 
            className="cta-button"
            onClick={() => onSectionChange('bicycles')}
          >
            Explore Our Inventory
          </button>
        </div>
      </div>
      <div className="nature-background"></div>
    </section>
  );
};

export default Home;